import Tippy from "@tippyjs/react";
import $ from "jquery";
import { default as Moment, default as moment } from "moment";
import { useContext, useEffect, useState } from "react";
import "react-confirm-alert/src/react-confirm-alert.css";
import { Link, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import "tippy.js/dist/tippy.css";
import Breadcrumb from "../../components/Breadcrumb";
import Pagination from "../../components/Pagination";
import Header from "../../components/partials/Header";
import Sidebar from "../../components/partials/Sidebar";
import config from "../../config";
import editIcon from "../../images/icons/edit.png";
import filter from "../../images/icons/filter.png";
import viewIcon from "../../images/icons/view.png";
import { millionComma } from "../../utils";
import "./style.css";
import { formatAmount, formatStatusBadge } from "./util";
import { ConfigContext } from "../../App";
import { confirmAlert } from "react-confirm-alert";
import { FcApproval } from "react-icons/fc";
import { FaInfoCircle } from "react-icons/fa";

function PurchaseList(props) {
  const location = useLocation();

  const [user, setUser] = useState({});

  useEffect(function () {
    if (localStorage.getItem("inventory")) {
      setUser(JSON.parse(localStorage.getItem("inventory")).userData);
    }
  }, []);

  const initialState = {
    po_no: "",
    po_id: "",
    buyer_name: "",
    inv_no: "",
    from_date: "",
    to_date: "",
    branch_id: "",
    is_active: "",
    is_zero_value: "",
    sync_status: "",
  };
  let newFilter = location.state?.appliedFilter || initialState;
  let newFilterVisiblity = location.state?.filterDisplay;
  let backToCurrPage = location.state?.backToCurrent;

  const [formInputs, setFormInputs] = useState(newFilter);
  const [filtersVisible, setFiltersVisible] = useState(
    newFilterVisiblity === true ? true : false,
  );
  const [filterActive, setFilterActive] = useState(
    location.state?.appliedFilter ? true : false,
  );
  // const [formInputs, setFormInputs] = useState(initialState);
  // const [filtersVisible, setFiltersVisible] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [actionLoading, setActionLoading] = useState(null);
  const [list, setList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  // const [currentPage, setCurrentPage] = useState(1);
  const [currentPage, setCurrentPage] = useState(
    backToCurrPage ? backToCurrPage : 1,
  );
  const initialPageSize = location.state?.pageSize || 10;
  const [userCount, setUserCount] = useState(initialPageSize);
  const loginBranch = useContext(ConfigContext)?.loginBranch;
  const erpIntegration = useContext(ConfigContext)?.erpIntegration;
  const [isErpLoading, setIsErpLoading] = useState(false);
  const [totalPage, setTotalPage] = useState(0);
  const [filterDate, setFilterDate] = useState();
  let dates = filterDate && JSON.parse(filterDate.date);

  function handleInputDate(e) {
    setFilterDate((prevState) => {
      return {
        ...prevState,
        [e.target.name]: e.target.value,
      };
    });
  }

  function toggleItemDetail(id) {
    $(`#${id}`).is(":visible")
      ? $(`#${id}`).addClass("d-none")
      : $(`#${id}`).removeClass("d-none");
  }

  async function getList(isFilter = true, pageNo = null, perPage = userCount) {
    let json = {
      paginate: 1,
      page_no: (pageNo || currentPage) - 1,
      branch_id: JSON.parse(localStorage.getItem("inventory"))?.userData
        ?.branch_data?.[0]?.branch_id,
    };
    if (isFilter) {
      // if (dates) {
      //   formInputs.from_date = dates[0];
      //   formInputs.to_date = dates[1];
      // }
      json = {
        ...json,
        ...formInputs,
        branch_id:
          JSON.parse(localStorage.getItem("inventory"))?.userData
            ?.branch_data?.[0]?.branch_id || formInputs.branch_id,
      };
    }
    json.page_size = perPage;
    await $.post(
      `${config.apiUrl}/purchaseOrder/listPurchaseOrder`,
      JSON.stringify(json),
    )
      .done(function (res) {
        setCurrentPage(pageNo || currentPage);
        setList(res.data?.list || []);
        setTotalPage(res.data?.count || 0);
        setIsLoading(false);
        setIsSubmit(false);
      })
      .catch(function (err) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: err?.responseJSON?.data?.message || err?.responseJSON?.message,
          confirmButtonText: "OK",
          allowEnterKey: false,
          allowEscapeKey: false,
          allowOutsideClick: false,
          focusConfirm: true,
        });
      })
      .always(function () {
        setIsSubmit(false);
      });
  }

  useEffect(
    function () {
      getList(filterActive);
    },
    [currentPage],
  );

  function handleInputs(e) {
    setFormInputs({ ...formInputs, [e.target.id]: e.target.value });
  }

  function handleFilterVisibility() {
    if (filtersVisible) {
      setFiltersVisible(false);
      setFormInputs(initialState);
    } else {
      setFiltersVisible(true);
    }
  }

  function ApprovedBranch(po_id) {
    let branch_id = JSON.parse(localStorage.getItem("inventory"))?.userData
      ?.branch_data?.[0]?.branch_id;

    confirmAlert({
      title: "Are you sure?",
      message: `You want to approve purchase`,
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            setActionLoading(po_id);
            $.post(
              `${config.apiUrl}/purchaseOrder/manualAutoApprove`,
              JSON.stringify({ po_id: po_id }),
            )
              .done(function (res) {
                setActionLoading(null);
                getList(filtersVisible);
                setError("");
                console.log("sjgsdshdjsjdks", res?.data);
                setSuccess(res?.data);
                setTimeout(function () {
                  setSuccess("");
                }, 4000);
              })
              .catch(function (err) {
                setActionLoading(null);
                setSuccess("");
                setError(
                  err?.responseJSON?.data?.message ||
                    err?.responseJSON?.message,
                );
                setTimeout(function () {
                  setError("");
                }, 4000);
              });
          },
        },
        {
          label: "No",
          onClick: () => {},
        },
      ],
    });
  }
  const [exportIds, setExportIds] = useState([]);
  const [isExport, setIsExport] = useState(false);
  const getExportIds = (e) => {
    if (e.target.value == "All") {
      if (e.target.checked) {
        // if (
        //   moment(formInputs.challan_date).format("MM-DD-yy") >=
        //   moment().format("MM-DD-yy")
        // ) {
        //   setExportIds((prevState) => [
        //     ...prevState,
        //     ...list.map((v) =>
        //       v.is_active == 4 ||
        //       v.is_active == 3 ||
        //       v.is_active == 2 ||
        //       v.is_active == 6
        //         ? v.po_id
        //         : ""
        //     ),
        //   ]);
        // } else {
        //   setExportIds((prevState) => [
        //     ...prevState,
        //     ...list.map((v) => (v.is_active == 2 ? v.po_id : "")),
        //   ]);
        // }
        // setExportIds((prevState) => [
        //   ...prevState,
        //   ...list.map((v) => v.po_id),
        // ]);

        setExportIds((prevState) => [
          ...prevState,
          ...list
            .map((v) =>
              v.is_zero_value == 0 && v.is_active == 2 ? v.po_id : "",
            )
            .filter(Boolean),
        ]);
      } else {
        setExportIds(() => []);
      }
    } else {
      const val = e.target.value;
      if (e.target.checked) {
        setExportIds((prevState) => [
          ...prevState,
          val.match(/^\d+$/) ? Number(val) : val,
        ]);
      } else {
        setExportIds((prevState) => prevState.filter((v) => v != val));
      }
    }
  };

  const downloadExportJson = async () => {
    if (exportIds.length == 0) {
      Swal.fire("", "Select atleast one Purchase Order");
      return;
    }
    let branch_id =
      JSON.parse(localStorage.getItem("inventory"))?.userData?.branch_data?.[0]
        ?.branch_id || formInputs.branch_id;
    setIsExport(true);
    await $.post(
      `${config.apiUrl}/purchaseOrder/exportPurchase`,
      JSON.stringify({
        purchase_order_ids: exportIds,
        branch_id: branch_id,
      }),
    )
      .done(function (res) {
        const jsonData = new Blob([JSON.stringify(res, null, 3)], {
          type: "text/json",
        });
        const jsonURL = window.URL.createObjectURL(jsonData);
        const link = document.createElement("a");
        link.href = jsonURL;

        link.setAttribute("download", "Purchase.json");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setIsExport(false);
        getList(filterActive);
      })
      .catch(function (err) {
        setIsExport(false);
        Swal.fire(
          "Error",
          err?.responseJSON?.data?.message || err?.responseJSON?.message,
        );
      });
  };

  const sendERP = async (type = "ERP") => {
    if (exportIds.length == 0) {
      Swal.fire("", "Select atleast one Purchase Order");
      return;
    }

    const selectedItems = list.filter((x) => exportIds.includes(x.po_id));
    const alreadySynced = selectedItems.filter((x) => x.sync_status == 1);

    if (alreadySynced.length > 0) {
      const nos = alreadySynced.map((x) => x.po_no).join(", ");
      Swal.fire({
        icon: "warning",
        title: "Already synced",
        text: `Purchase Order no ${nos} are already synced successfully. Please untick them first and then Send to ERP.`,
        confirmButtonText: "OK",
      });
      return;
    }

    setIsErpLoading(true);
    await $.post(
      `${config.apiUrl}/purchaseOrder/updateErpStatus`,
      JSON.stringify({
        po_ids: exportIds,
        is_erp: 1,
        type: type,
      }),
    )
      .done(function (res) {
        setIsErpLoading(false);
        Swal.fire({
          icon: "success",
          title: "Success",
          text:
            res?.data?.message ||
            (type === "NON-ERP"
              ? "Purchase Order successfully marked for Non ERP."
              : "Purchase Order successfully sent to ERP."),
        });
        getList(filterActive);
      })
      .catch(function (err) {
        setIsErpLoading(false);
        Swal.fire({
          icon: "error",
          title: "Error",
          text:
            err?.responseJSON?.data?.message ||
            err?.responseJSON?.message ||
            "Something went wrong while sending to ERP",
        });
      });
  };
  const changePageSize = async (e) => {
    setUserCount(() => e.target.value);
    // setFormInputs((prevState) => {
    //   return { ...prevState, page_size: e.target.value };
    // });
    if (list.length > 0) {
      currentPage == 1
        ? await getList(
            {
              ...formInputs,
              // page_size: e.target.value,
            },
            null,
            e.target.value,
          )
        : setCurrentPage(() => 1);
    }
  };
  return (
    <>
      <div
        className="d-flex min-vh-100 main-Wrapper"
        style={{ background: "#DAE5FF" }}
      >
        <Sidebar />
        <div className="content m-1 p-2">
          <Header />

          <main className="bg-white rounded-4" id="purchase">
            <div className="container-fluid p-2">
              <div className="row">
                <div className="col">
                  <Breadcrumb path={["Purchase"]} />
                </div>
                <div className="col text-end">
                  <Tippy content="Filter">
                    <img
                      onClick={() => handleFilterVisibility()}
                      src={filter}
                      className="img-fluid me-3"
                      alt=""
                      role="button"
                      style={{ width: "2rem" }}
                    />
                  </Tippy>

                  {/* {user?.role_id === 3 && (
                                    <>
                                        <Link
                                            to="/purchase/add"
                                            className="btn btn-primary px-4 py-2">
                                            New Purchase
                                        </Link>
                                    </>
                                )} */}
                  <span className=" me-3">
                    <label className="me-1">Per Page</label>
                    <select
                      value={userCount}
                      onChange={(e) => changePageSize(e)}
                      className="custom-select"
                      style={{ height: "32px" }}
                    >
                      <option value="10">10</option>
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </span>
                  {user.role_id !== 2 ? (
                    <Link
                      to="/purchase/add"
                      className="btn btn-primary px-4 py-2"
                      style={{
                        height: "33px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        float: "right",
                      }}
                    >
                      New Purchase
                    </Link>
                  ) : (
                    ""
                  )}
                </div>
              </div>

              {filtersVisible && (
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    setIsSubmit(true);
                    setFilterActive(true);
                    currentPage > 1 ? setCurrentPage(1) : getList(true, 1);
                  }}
                  id="purchaseAdd"
                  className="my-3"
                  autoComplete="off"
                >
                  <div className="row g-3 mb-2">
                    <div className="col-md">
                      <label htmlFor="buyer_name">Supplier Name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="buyer_name"
                        value={formInputs.buyer_name}
                        onChange={handleInputs}
                      />
                    </div>
                    <div className="col-md">
                      <label htmlFor="po_no">Purchase No</label>
                      <input
                        type="text"
                        className="form-control"
                        id="po_no"
                        value={formInputs.po_no}
                        onChange={handleInputs}
                      />
                    </div>
                    <div className="col-md">
                      <label htmlFor="inv_no">Invoice No</label>
                      <input
                        type="text"
                        className="form-control"
                        id="inv_no"
                        value={formInputs.inv_no}
                        onChange={handleInputs}
                      />
                    </div>
                    {/* <DateRangeFilter
                      filterDate={filterDate}
                      onChange={handleInputDate}
                    /> */}
                    <div className="col-md">
                      <label htmlFor="from_date">From Date</label>
                      <input
                        type="date"
                        className="form-control"
                        id="from_date"
                        value={formInputs.from_date}
                        onChange={handleInputs}
                        max={moment().format("YYYY-MM-DD")}
                      />
                    </div>
                    <div className="col-md">
                      <label htmlFor="to_date">To Date</label>
                      <input
                        type="date"
                        className="form-control"
                        id="to_date"
                        value={formInputs.to_date}
                        onChange={handleInputs}
                        max={moment().format("YYYY-MM-DD")}
                      />
                    </div>
                    <div className="col-md">
                      <label htmlFor="is_zero_value">Zero Valued</label>
                      <select
                        className="form-select"
                        id="is_zero_value"
                        name="is_zero_value"
                        value={formInputs.is_zero_value}
                        onChange={(e) =>
                          setFormInputs({
                            ...formInputs,
                            is_zero_value: e.target.value,
                          })
                        }
                      >
                        <option value="">All</option>
                        <option value="0">No</option>
                        <option value="1">Yes</option>
                      </select>
                    </div>
                    {user.role_id != 3 && user.role_id != 4 && (
                      <div className="col-md">
                        <label htmlFor="branch_id">Branch</label>
                        <select
                          className="form-select"
                          id="branch_id"
                          name="branch_id"
                          value={formInputs.branch_id}
                          onChange={(e) =>
                            setFormInputs({
                              ...formInputs,
                              branch_id: e.target.value,
                            })
                          }
                        >
                          <option value={""}>select...</option>
                          {props.branchList.map((v, i) => (
                            <option key={i} value={v.value}>
                              {v.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}
                    <div className="col-md">
                      <label htmlFor="status">Status</label>
                      <select
                        className="form-select"
                        id="is_active"
                        name="is_active"
                        value={formInputs.is_active}
                        onChange={(e) =>
                          setFormInputs({
                            ...formInputs,
                            is_active: e.target.value,
                          })
                        }
                      >
                        {[
                          { id: "", name: "All" },
                          { id: 1, name: "Pending" },
                          { id: 2, name: "Approved" },
                          { id: 4, name: "Partial Done" },
                          {
                            id: 3,
                            name: "Rejected",
                          },
                        ].map((v, i) => (
                          <option
                            key={i}
                            value={v.id}
                            className={v.id === 0 ? "bg-lightgrey" : ""}
                          >
                            {v.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    {erpIntegration == 1 ? (
                      <div className="col-md">
                        <label htmlFor="sync_status">Sync Status</label>
                        <select
                          className="form-select"
                          id="sync_status"
                          name="sync_status"
                          value={formInputs.sync_status}
                          onChange={(e) =>
                            setFormInputs({
                              ...formInputs,
                              sync_status: e.target.value,
                            })
                          }
                        >
                          {[
                            { id: "", name: "All" },
                            { id: 0, name: "Pending" },
                            { id: 1, name: "Success" },
                            { id: 2, name: "Failed" },
                          ].map((v, i) => (
                            <option
                              key={i}
                              value={v.id}
                              className={v.id === 0 ? "bg-lightgrey" : ""}
                            >
                              {v.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    ) : null}
                  </div>
                  <div className="row mt-3">
                    <div className="col-md" style={{ display: "flex" }}>
                      <button
                        className="btn btn-primary"
                        type="submit"
                        disabled={isSubmit}
                        style={{
                          height: "35px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        {isSubmit && (
                          <span className="spinner-border spinner-border-sm me-2"></span>
                        )}
                        Search
                      </button>
                      <button
                        className="btn btn-primary rounded-3 px-3 ms-2 text-white"
                        type="reset"
                        onClick={(e) => {
                          setFormInputs(initialState);
                          setFilterDate();
                          currentPage > 1
                            ? setCurrentPage(1)
                            : getList(false, 1);
                        }}
                        style={{
                          background: "#4263eb",
                          fontSize: "14px",
                          height: "35px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        Clear Filters
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary py-0 ms-2"
                        style={{
                          background: "#4263eb",
                          borderRadius: "8px",
                          fontWeight: "600",
                          fontSize: "14px",
                          height: "35px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          color: "#ffffff",
                        }}
                        onClick={downloadExportJson}
                      >
                        {isExport && (
                          <span className="spinner-border spinner-border-sm me-2"></span>
                        )}
                        Export
                      </button>
                      {erpIntegration == 1 ? (
                        <div className="btn-group ms-2">
                          <button
                            type="button"
                            className="btn btn-primary"
                            style={{
                              background: "#4263eb",
                              borderColor: "#4263eb",
                              borderTopLeftRadius: "8px",
                              borderBottomLeftRadius: "8px",
                              fontWeight: "600",
                              fontSize: "14px",
                              height: "35px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              color: "#ffffff",
                              whiteSpace: "nowrap",
                            }}
                            onClick={() => sendERP("ERP")}
                            disabled={isErpLoading}
                          >
                            {isErpLoading && (
                              <span className="spinner-border spinner-border-sm me-2"></span>
                            )}
                            Mark For ERP
                          </button>
                          <button
                            type="button"
                            className="btn btn-primary dropdown-toggle dropdown-toggle-split"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            disabled={isErpLoading}
                            style={{
                              background: "#3b5bdb",
                              borderColor: "#3b5bdb",
                              borderTopRightRadius: "8px",
                              borderBottomRightRadius: "8px",
                              height: "35px",
                              color: "#ffffff",
                              paddingLeft: "10px",
                              paddingRight: "10px",
                            }}
                          >
                            <span className="visually-hidden">Toggle Dropdown</span>
                          </button>
                          <ul
                            className="dropdown-menu dropdown-menu-end shadow"
                            style={{ minWidth: "160px", zIndex: 1050 }}
                          >
                            <li>
                              <button
                                type="button"
                                className="dropdown-item py-2 fw-semibold"
                                onClick={() => sendERP("erp")}
                              >
                                Mark For ERP
                              </button>
                            </li>
                            <li>
                              <button
                                type="button"
                                className="dropdown-item py-2 fw-semibold"
                                onClick={() => sendERP("NON-ERP")}
                              >
                                Mark For Non ERP
                              </button>
                            </li>
                          </ul>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </form>
              )}

              {(error || success) && (
                <div className="row mt-3">
                  <div className="col">
                    <div
                      className={`alert alert-${
                        error ? "danger" : "success"
                      } py-1 small`}
                      role="alert"
                    >
                      {error || success || ""}
                    </div>
                  </div>
                </div>
              )}

              <div className="row mb-4">
                <div className="col table-responsive-lg">
                  <table
                    className={`table ${
                      error || success ? "my-1" : "mt-4"
                    } rounded`}
                  >
                    <thead>
                      <tr>
                        <th>
                          <input
                            type="checkbox"
                            id="All"
                            value="All"
                            onChange={(e) => getExportIds(e)}
                          />
                        </th>
                        <th>PO No</th>
                        <th>Invoice No</th>
                        <th>Supplier Name</th>
                        {user.role_id === 2 ? <th>Branch</th> : ""}
                        <th className="text-end">Amount</th>
                        <th>Purchase Date</th>
                        <th className="text-end">Export Count</th>
                        <th>Zero Valued</th>
                        <th>Status</th>
                        {erpIntegration == 1 ? <th>Sync Status</th> : null}
                        <th style={{ width: "105px" }}>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(isLoading || list.length === 0) && (
                        <tr>
                          <td
                            colSpan={erpIntegration == 1 ? (user.role_id === 2 ? 10 : 9) : (user.role_id === 2 ? 9 : 8)}
                            className="text-center"
                          >
                            {isLoading ? "Loading..." : "No Records"}
                          </td>
                        </tr>
                      )}
                      {list &&
                        list.map((v, i) => (
                          <>
                            <tr
                              key={`pl_` + i}
                              // className={v.is_active ? "" : "bg-lightgrey"}

                              className={
                                v?.export_count > 0
                                  ? ""
                                  : v.is_active
                                    ? ""
                                    : "bg-lightgrey"
                              }
                              style={
                                v?.export_count > 0
                                  ? {
                                      backgroundColor: `rgba(var(--theme-btn-color-rgb, 13, 202, 240), ${Math.min(
                                        v?.export_count * 0.15,
                                        1,
                                      )})`,
                                    }
                                  : {}
                              }
                            >
                              <td>
                                {v?.is_zero_value == 0 && (
                                  <input
                                    type="checkbox"
                                    value={v?.po_id}
                                    checked={exportIds.includes(v?.po_id)}
                                    // className={`${
                                    //   moment(v.challan_date).format("MM-DD-yy") >=
                                    //     moment().format("MM-DD-yy") &&
                                    //   (v?.is_active == 1 ||
                                    //     v?.is_active == 2 ||
                                    //     v?.is_active == 3 ||
                                    //     v.is_active == 5 ||
                                    //     v.is_active == 6)
                                    //     ? "d-none"
                                    //     : ""
                                    // }`}
                                    className={`${
                                      v?.is_active != 2 ? "d-none" : ""
                                    }`}
                                    onChange={(e) => getExportIds(e)}
                                  />
                                )}
                              </td>
                              <td>
                                <span
                                  className="link-primary user-select-none"
                                  role="button"
                                  onClick={() => toggleItemDetail(`pli_${i}`)}
                                >
                                  {v.po_no}
                                </span>
                              </td>
                              <td>{v.inv_no}</td>
                              <td>
                                <span title={v.mst_buyer.buyer_name}>
                                  {v.mst_buyer.buyer_name.length > 15
                                    ? v.mst_buyer.buyer_name
                                        .toString()
                                        .substring(0, 15) + "..."
                                    : v.mst_buyer.buyer_name}
                                </span>
                              </td>
                              {user.role_id === 2 ? (
                                <td>
                                  {props?.branchList?.find(
                                    (el) => el?.value === v?.branch_id,
                                  )?.label || "N/A"}
                                </td>
                              ) : (
                                ""
                              )}
                              <td className="text-end">{formatAmount(v)}</td>
                              <td>
                                {Moment(v.po_date, "YYYY-MM-DD").format(
                                  "DD-MM-YYYY",
                                )}
                              </td>
                              <td className="text-end">
                                {v?.export_count || "0"}
                              </td>
                              <td>
                                {v?.is_zero_value == 1
                                  ? "Yes"
                                  : v?.is_zero_value == 0
                                    ? "No"
                                    : "NA"}
                              </td>

                              <td className="">{formatStatusBadge(v)}</td>
                              {erpIntegration == 1 && (
                                <td>
                                  {v.is_erp == 1
                                    ? (() => {
                                      const status = v?.sync_status;

                                      if (status === 0) {
                                        return (
                                          <span
                                            className="badge bg-warning"
                                            style={{ fontSize: "11px" }}
                                          >
                                            Pending
                                          </span>
                                        );
                                      }

                                      if (status === 1) {
                                        return (
                                          <span
                                            className="badge bg-success"
                                            style={{ fontSize: "11px" }}
                                          >
                                            Success
                                          </span>
                                        );
                                      }

                                      if (status === 2) {
                                        return (
                                          <>
                                            <span
                                              className="badge bg-danger"
                                              style={{ fontSize: "11px" }}
                                            >
                                              Failed
                                            </span>

                                            <Tippy
                                              content={
                                                v?.sync_err || "Sync Error"
                                              }
                                            >
                                              <span
                                                style={{ cursor: "pointer" }}
                                              >
                                                <FaInfoCircle
                                                  style={{
                                                    fontSize: "15px",
                                                    marginLeft: "5px",
                                                  }}
                                                />
                                              </span>
                                            </Tippy>
                                          </>
                                        );
                                      }

                                      return (
                                        <span className="text-muted">-</span>
                                      );
                                    })()
                                    : "NA"}
                                </td>
                              )}
                              <td className="edit">
                                <Tippy content="View">
                                  <Link
                                    to={`/purchase/view/` + v.po_id}
                                    state={{
                                      purchase: v,
                                      currentPageNo: currentPage,
                                      currentFilter: formInputs,
                                      showFilter: filtersVisible,
                                      pageSize: userCount,
                                    }}
                                    className={`link-info m-1`}
                                  >
                                    <img
                                      src={viewIcon}
                                      className="img-fluid"
                                      alt=""
                                    />
                                  </Link>
                                </Tippy>

                                {/* Visible When Rejected */}
                                {(user?.role_id === 3 ||
                                  user?.role_id === 4) && (
                                  <>
                                    {(v.is_active == 1 ||
                                      v.is_active == 4 ||
                                      (v.is_active == 2 &&
                                        v.is_zero_value == 1)) && (
                                      <Tippy content="Edit">
                                        <Link
                                          to={`/purchase/edit/` + v.po_id}
                                          state={{
                                            purchase: v,
                                            currentPageNo: currentPage,
                                            currentFilter: formInputs,
                                            showFilter: filtersVisible,
                                            pageSize: userCount,
                                          }}
                                          className={`link-info m-1`}
                                        >
                                          <img
                                            src={editIcon}
                                            className="img-fluid"
                                            alt=""
                                          />
                                        </Link>
                                      </Tippy>
                                    )}
                                    {loginBranch?.auto_approve &&
                                      loginBranch?.branch_id === v.branch_id &&
                                      v.is_active === 1 && (
                                        <Tippy content="Approve">
                                          <a
                                            href="#cancel"
                                            onClick={(e) => {
                                              e.preventDefault();
                                              ApprovedBranch(v.po_id);
                                            }}
                                            className="link-info"
                                          >
                                            {actionLoading === v.po_id ? (
                                              <span className="spinner-border spinner-border-sm"></span>
                                            ) : (
                                              <FcApproval size={24} />
                                            )}
                                          </a>
                                        </Tippy>
                                      )}
                                  </>
                                )}
                              </td>
                            </tr>
                            <tr
                              key={`pli_` + i}
                              id={`pli_` + i}
                              className="d-none"
                            >
                              <td colSpan={`${user.role_id === 2 ? "8" : "7"}`}>
                                <div className="table-responsive">
                                  <table className="table table-sm table-bordered ms-auto w-50 py-0 mb-0">
                                    <thead>
                                      <tr style={{ textAlign: "center" }}>
                                        <th>#</th>
                                        <th>Item Name</th>
                                        <th>Qty</th>
                                        <th>Rate</th>
                                        <th>Total</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {v?.item_dtl &&
                                        v.item_dtl.map((v, i) => (
                                          <tr key={`plil_` + i}>
                                            <td>{i + 1}</td>
                                            <td>{v?.mst_item?.item_name}</td>
                                            <td className="text-end">
                                              {parseFloat(
                                                v?.po_qty || 0,
                                              ).toFixed(2)}
                                            </td>
                                            <td className="text-end">
                                              {millionComma(v?.rate)}
                                            </td>
                                            <td className="text-end">
                                              {millionComma(v?.amount)}
                                            </td>
                                          </tr>
                                        ))}
                                      <tr>
                                        <td
                                          colSpan="4"
                                          className="text-end pe-2 fw-bold"
                                        >
                                          Gross Total
                                        </td>
                                        <td className="fw-bold text-end">
                                          {formatAmount(v)}
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </td>
                            </tr>
                          </>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="row">
                <div className="col">
                  <Pagination
                    nPages={Math.ceil(totalPage / userCount)}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                  />
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </>
  );
}

export default PurchaseList;
